import React from 'react';
import ChangePasswordSection from '../components/ChangePassword/Section';

const ChangePassword = () => {
  return (
    <ChangePasswordSection />
  )
}

export default ChangePassword